import React, {ChangeEvent, FormEvent, ReactElement, useState} from "react";
import {useQueryParams} from "../hooks/useQueryParams";
import axios from "axios";
import {message} from "antd";
import {useIntl} from "react-intl";

export type AccountPasswordLoginFormProps = {
    username: string
    changeUsername: (e: ChangeEvent<HTMLInputElement>) => void
    password: string
    changePassword: (e: ChangeEvent<HTMLInputElement>) => void
    loginLoading: boolean
    show: boolean
}

export function withAccountPasswordLoginForm(WrappedComponent: React.FC<AccountPasswordLoginFormProps>) {
    return (props: {show: boolean}) => {
        let intl = useIntl();
        const [username, setUsername] = useState('');
        const [password, setPassword] = useState('');
        const [loginLoading, setLoginLoading] = useState(false);
        const queryParams = useQueryParams();

        const onLogin = (e: FormEvent<HTMLFormElement>) => {
            e.preventDefault()
            if (!username) {
                return message.error(intl.formatMessage({id: '用户名不能为空'}))
            }
            if (!password) {
                return message.error(intl.formatMessage({id: '密码不能为空'}))
            }
            setLoginLoading(true)
            axios.create().post(`${process.env.REACT_APP_ACCOUNT_URL}api/oauth2/login.htm`, {
                oauth2Info: queryParams,
                accountBean: {
                    account: username,
                    password
                }
            }).then(data => {
                setLoginLoading(false)
                if (data.data.status === '0') {
                    window.top.location.href = data.data.data.redirectUrl.replace('http://', 'https://');
                    return;
                }
                message.error(data.data.desc);
            });
        }
        const inputChangeHandler = (handler: (v: string) => void) => {
            return (e: ChangeEvent<HTMLInputElement>) => {
                handler(e.target.value)
            }
        }
        return (
            <form className={'form'} onSubmit={onLogin} style={{display: props.show ? '' : 'none'}}>
                <WrappedComponent
                    {...props}
                    username={username}
                    changeUsername={inputChangeHandler(setUsername)}
                    password={password}
                    changePassword={inputChangeHandler(setPassword)}
                    loginLoading={loginLoading} />
            </form>
        )
    }
}
